var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"}},[_c('rect',{attrs:{"width":"24","height":"24","fill":"#000","fill-opacity":".08","rx":"12"}}),_c('path',{attrs:{"stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M7 17 17 7M7 7l10 10"}})])
}
var staticRenderFns = []

export default { render: render }